import {createContext, useContext, useState} from "react";
import {fetchPost} from "../utils/fetch";
import {url} from "../utils/urls";

const authContext = createContext("auth");

export function AuthProvider({ children }) {
  // eslint-disable-next-line no-undef
  const [authed, setAuthed] = useState(_LOGGED_IN);
  const [lottery, setLottery] = useState(_LOTTERY);
  const [egifted, setEGifted] = useState(_EGIFT);
  const [theme, setTheme] = useState("black");

  // --------------
  // Login
  // --------------
  const login = ({recept_number, login_id}) => {
    return fetchPost({
      action: url("/api/login/valid"),
      data: {recept_number: recept_number, login_id: login_id},
    });
  };

  // --------------
  // Logout
  // --------------
  const logout = () => {
    return fetchPost({
      action: url("/api/login/logout"),
    });
  };

  return (
    <authContext.Provider value={{
      authed, login, logout, setAuthed, theme, setTheme, lottery, setLottery, egifted, setEGifted
    }}>
      {children}
    </authContext.Provider>
  );
}

export default function AuthConsumer() {
  return useContext(authContext);
}
